import Axios from "axios";
import useAuth from "@/composables/useAuth";
import { getAppGlobals } from "@/plugins/appGlobals";

export const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_WEB
});

export const userSessionName = "loggedClientLilaMedico";

export const apiApp = process.env.VUE_APP_API_APP;

axios.defaults.withCredentials = true;

export const signalApi = process.env.VUE_APP_SIGNAL_API;

export const calendarApi = process.env.VUE_APP_API_CALENDAR;


axios.interceptors.response.use(
  (response) => {
    if (response.config && response.config._retryCount) {
      response.config._retryCount = 0;
    }
    return response;
  },
  // se recebeu 401, tenta renovar o token
  async (error) => {
    if (error.response && error.response.status === 401) {
      error.config._retryCount = error.config._retryCount || 0;

      if (error.config._retryCount >= 3) {
        return Promise.reject(error);
      }

      error.config._retryCount += 1;

      const { refreshLogin } = useAuth();
      try {
        await refreshLogin();

        // Atualiza o header com o token RENOVADO antes de refazer a chamada
        const app = getAppGlobals();
        const newToken = app.$Session.get(app.$userSessionName)?.token?.Value;
        error.config.headers = error.config.headers || {};
        if (newToken) {
          error.config.headers.Authorization = `bearer ${newToken}`;
        }

        return axios(error.config);
      } catch (e) {
        return Promise.reject(e);
      }
    }
    return Promise.reject(error);
  }
);

export default axios;